import ApplicationController from './application_controller'

// TPK-4218 — dynamic rules for the Incident Mapping edit form:
//   trigger_mode automatic → trigger_code + trigger_condition shown & required
//   trigger_mode manual    → those fields hidden & not required
//   email_target empty     → followup_delay cleared & disabled
//   followup_delay present → email_target required
export default class extends ApplicationController {
  static targets = [
    'mode', 'codeRow', 'code', 'conditionRow', 'condition', 'email', 'followup'
  ]

  connect () {
    this.syncTrigger()
    this.syncNotifications()
    // Disabled fields are not submitted; re-enable on submit so a cleared
    // followup posts as blank and the server state stays consistent.
    this.boundEnableFollowup = this.enableFollowup.bind(this)
    this.element.addEventListener('submit', this.boundEnableFollowup)
  }

  disconnect () {
    this.element.removeEventListener('submit', this.boundEnableFollowup)
  }

  syncTrigger () {
    const automatic = this.modeTarget.value === 'automatic'

    this.toggle(this.codeRowTarget, automatic)
    this.toggle(this.conditionRowTarget, automatic)
    this.setRequired(this.codeTarget, this.codeRowTarget, automatic)
    this.setRequired(this.conditionTarget, this.conditionRowTarget, automatic)
  }

  syncNotifications () {
    const hasTarget = this.emailTarget.value !== ''

    if (!hasTarget) this.followupTarget.value = ''
    this.followupTarget.disabled = !hasTarget

    const emailRow = this.emailTarget.closest('li')
    this.setRequired(this.emailTarget, emailRow, this.followupTarget.value !== '')
  }

  enableFollowup () {
    this.followupTarget.disabled = false
  }

  toggle (row, visible) {
    row.hidden = !visible
  }

  // Toggles the HTML constraint AND Formtastic's visual marker: the `*` lives
  // in an <abbr> inside the label and the row carries a required/optional class,
  // both rendered server-side, so they must be synced live.
  setRequired (input, row, required) {
    input.toggleAttribute('required', required)
    if (!row) return

    row.classList.toggle('required', required)
    row.classList.toggle('optional', !required)

    const label = row.querySelector('label.label')
    if (!label) return

    const abbr = label.querySelector('abbr')
    if (required && !abbr) {
      label.insertAdjacentHTML('beforeend', '<abbr title="required">*</abbr>')
    } else if (!required && abbr) {
      abbr.remove()
    }
  }
}
